import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconResourceTypeImgSmall = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33333 2.75C3.01117 2.75 2.75 3.01117 2.75 3.33333V12.6667C2.75 12.9888 3.01117 13.25 3.33333 13.25H12.6667C12.9888 13.25 13.25 12.9888 13.25 12.6667V3.33333C13.25 3.01117 12.9888 2.75 12.6667 2.75H3.33333ZM1.25 3.33333C1.25 2.18274 2.18274 1.25 3.33333 1.25H12.6667C13.8173 1.25 14.75 2.18274 14.75 3.33333V12.6667C14.75 13.8173 13.8173 14.75 12.6667 14.75H3.33333C2.18274 14.75 1.25 13.8173 1.25 12.6667V3.33333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6665 5.41602C5.52843 5.41602 5.4165 5.52794 5.4165 5.66602C5.4165 5.80409 5.52843 5.91602 5.6665 5.91602C5.80458 5.91602 5.9165 5.80409 5.9165 5.66602C5.9165 5.52794 5.80458 5.41602 5.6665 5.41602ZM3.9165 5.66602C3.9165 4.69952 4.70001 3.91602 5.6665 3.91602C6.633 3.91602 7.4165 4.69952 7.4165 5.66602C7.4165 6.63251 6.633 7.41602 5.6665 7.41602C4.70001 7.41602 3.9165 6.63251 3.9165 5.66602Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1365 6.13569C10.4294 5.84279 10.9043 5.84279 11.1972 6.13569L14.5305 9.46902C14.8234 9.76191 14.8234 10.2368 14.5305 10.5297C14.2376 10.8226 13.7627 10.8226 13.4698 10.5297L10.6668 7.72668L3.86383 14.5297C3.57093 14.8226 3.09606 14.8226 2.80317 14.5297C2.51027 14.2368 2.51027 13.7619 2.80317 13.469L10.1365 6.13569Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
